<template>
    <b-modal
        id="sub-assignment-show-logs"
        title="Opdrachtgeschiedenis"
        modal-class="apprentice-default-modal"
        ok-only
        size="lg"
        :ok-title="$t('common.close')">
        <div v-if="activitiesIn.length">
            <design-2021-apprentice-data-table
                :fields="fields"
                :items="activitiesIn">
                <template v-slot:cell(old_status)="data">
                    {{ data.item.getOldStatusText() }}
                </template>

                <template v-slot:cell(new_status)="data">
                    {{ data.item.getNewStatusText() }}
                </template>

                <template v-slot:cell(created_at)="data">
                    {{ data.item.created_at | date_time_om }}
                </template>
            </design-2021-apprentice-data-table>
        </div>

        <div v-else>Nog geen geschiedenis aanwezig</div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-assignment-show-sub-assignment-logs-modal-component',
    props: ['logsIn', 'activitiesIn'],
    data() {
        return {
            fields: [
                {
                    key: 'causer.full_name',
                    label: 'Door',
                    sortable: true,
                },
                {
                    key: 'old_status',
                    label: 'Oude status',
                    sortable: true,
                },
                {
                    key: 'new_status',
                    label: 'Nieuwe status',
                    sortable: true,
                },
                {
                    key: 'created_at',
                    label: 'Datum',
                    sortable: true,
                },
            ],
        };
    },
};
</script>

<style scoped></style>
